'use strict'

import BaseService from './baseService'
import { Constants } from '../utils/constants'

const serviceURL = `/api/${Constants.BASE_API_VERSION}/compassionateLeaveRequests`

export default class CompassionateLeaveRequestService extends BaseService {
  async getNumberOfDaysTaken(employeeId, year) {
    let result = await this.sendRequest('GET', `${serviceURL}/DaysTaken/${employeeId}/${year}`)
    return result.data
  }
}
